import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'
import { Title } from 'components/layout'
import styles from './view-message.styl'

export default class ViewMessage extends Component {
  static propTypes = {
    message: PropTypes.string
  }

  render() {
    const { message } = this.props

    return (
      <div>
        <Title h2 intlKey={'moduleTitle.message_title'}>
         Message
        </Title>
        {message ? <FormattedHTMLMessage id="message.content" className={styles.note} defaultMessage={message} />
        : <FormattedMessage id="label.no_message" defaultMessage="No message" />}
      </div>
    )
  }
}
